import { useFormContext } from 'react-hook-form';
import type { SelectedIntegration } from 'src/store/slices/integrationSlice';
import { ZohoEmailApiFields } from 'src/components/Integrations/IntegrationForms/IntegrationFormFields/ZohoEmailApiFields/ZohoEmailApiFields';

export const EditZohoEmailApiDetailsSettings = ({
  integration,
}: {
  integration?: SelectedIntegration;
}) => {
  const { control } = useFormContext();
  return (
    <div className={'w-full flex flex-col gap-2.5 p-2.5 bg-[#A498FF1A] rounded-sm-5'}>
      <ZohoEmailApiFields control={control} />
    </div>
  );
};
